import { render } from "./SelectSmallNumbers.vue?vue&type=template&id=1b5b8f52&scoped=true"
import script from "./SelectSmallNumbers.vue?vue&type=script&lang=js"
export * from "./SelectSmallNumbers.vue?vue&type=script&lang=js"

import "./SelectSmallNumbers.vue?vue&type=style&index=0&id=1b5b8f52&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5b8f52"]])

export default __exports__